<script setup>
import { useQuasar } from 'quasar'
import usePurchase from '../../../store/purchase.store'
import { callApi, formatTime } from '../../../utils'
import Table from '../../shared/Table.vue'
import { useI18n } from "vue-i18n"
import { ref, onMounted, onUnmounted } from 'vue'

const { t } = useI18n()

const {
  purchaseList,
  getPurchaseList,
  loading,
  pagination,
  filterOptions,
  updatePurchase,
} = usePurchase()

const $q = useQuasar()

const columns = [
  { name: 'createdAt', align: 'left', label: t("table.columns.createdAt"), field: 'createdAt', format: v => formatTime(v) },
  { name: 'deviceNumber', align: 'left', label: t("device.id"), field: 'deviceNumber' },
  { name: 'customerPhone', align: 'left', label: t("purchase.customer.phone"), field: 'customerPhone' },
  { name: 'energy', align: 'right', label: `${t("purchase.energy")} (${t("values.kw")})`, field: 'energy' },
  { name: 'waitingTime', align: 'right', label: `${t("purchase.waitingTime")} (hh:mm:ss)`, field: 'waitingTimeParsed' },
  { name: 'parkingAmount', align: 'right', label: `${t("purchase.parkingAmount")} (₮)`, field: 'parkingAmount' },
  { name: 'energyAmount', align: 'right', label: `${t("purchase.energyAmount")} (₮)`, field: 'energyAmount' },
  { name: 'amount', align: 'right', label: `${t("purchase.amount")} (₮)`, field: 'amount' },
  { name: 'status', align: 'left', label: t("purchase.status"), field: 'status' },
]

function paginate (props) {
  callApi([getPurchaseList], {
    ...filterOptions.value,
    page: parseInt(props.pagination.page),
    "page-size": parseInt(props.pagination.rowsPerPage)
  }, $q, loading)
}

callApi([getPurchaseList], {
  'page-size': parseInt(pagination.value.rowsPerPage)
}, $q, loading)

let intervalId = null

onMounted(() => {
  intervalId = setInterval(updatePurchase, 1000)
})

onUnmounted(() => {
  clearInterval(intervalId)
})

console.log("Purchase list: ", purchaseList);
</script>

<template lang='pug'>
.purchase-list
  Table(
    :title='t("menu.purchases")'
    :rows='purchaseList'
    :loading='loading'
    :columns='columns'
    row-key='_id'
    v-model:pagination="pagination"
    @request="paginate"
  )
    template(v-slot:header='props')
      q-th(v-for="(col, index) in props.cols" :key="col.name")
        div {{ col.label }}

    template(v-slot:body='props')
      q-td(v-for="col in props.cols" :key="col.name" )
        div(v-if="col.name==='status'")
          q-badge(rounded color='grey-9')
            | {{ t(`purchase.statuses.${col.value}`) }}
        div(v-else) 
          | {{ col.value }}
</template>